import React from 'react';
import LegalPage from './LegalPage';

const Privacy: React.FC = () => <LegalPage documentId="privacy" />;

export default Privacy;
